<template>
    <div class="row mb-2">
        <div class="col-12" v-if="errors.length">
            <div class="alert alert-danger small">
                <div v-for="error in errors">
                    {{error}}
                </div>
            </div>
        </div>
        <div class="col-1 text-center">
            <a class="text-danger" @click="deleteContact" title="Sterge">
                <i class="material-icons">
                    delete
                </i>
            </a>
            <a @click="toggleContact" :class="[getClass]" title="Activeaza/Dezactiveaza">
                <i class="material-icons notification-status">
                    {{status}}
                </i>
            </a>
        </div>
        <div class="col-4 handler">
            <form class="compact">
                <div class="text-danger">
                    {{getError('handler')}}
                </div>
                <div class="form-group row">
                    <label for="handler" class="col-4" :class="{'text-danger': hasError('handler')}">Contact</label>
                    <div class="col-8">
                        <input
                                id="handler"
                                type="text"
                                class="form-control form-control-sm"
                                v-model="contact.handler"
                                :class="{'border-danger': hasError('handler')}"
                        />
                    </div>
                </div>
                <div class="text-danger">
                    {{getError('priority')}}
                </div>
                <div class="form-group row">
                    <label for="priority" class="col-4" :class="{'text-danger': hasError('priority')}">Prioritate</label>
                    <div class="col-8">
                        <input
                                id="priority"
                                type="text"
                                class="form-control form-control-sm"
                                v-model.number="contact.priority"
                                :class="{'border-danger': hasError('priority')}"
                        />
                    </div>
                </div>
            </form>
        </div>
        <div class="col-7">
            <form class="form-inline d-inline-block" v-if="newLists.length">
                <div class="form-group">
                    <select class="my-1 mr-sm-2" @change="addNewList" v-model="addedList">
                        <option selected value="0">Adauga lista...</option>
                        <option v-for="list in newLists" :value="list">{{list.name}}</option>
                    </select>
                </div>
            </form>
            <div v-for="list in contact.lists" class="d-inline-block contact-list bg-light">
                <a @click="removeList(list)">
                    <i class="material-icons bg-danger text-white">
                        clear
                    </i>
                </a>
                {{list.name}}
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import ErrorPrinter from '../mixins/ErrorPrinter'
    export default {
        mixins: [ErrorPrinter],
        props: {
            id: {
                type: Number,
                required: false
            },
            index: {
                type: Number,
                required: true
            },
            handler: {
                type: String,
                required: false
            },
            is_active: {
                type: Boolean,
                required: false
            },
            priority: {
                type: Number,
                required: false
            },
            lists: {
                type: Array,
                required: false
            },
            errors: {
                type: Object,
            }
        },
        data: () => {
            return {
                contact: {
                    id: null,
                    handler: null,
                    is_active: false,
                    priority: 1000,
                    lists: []
                },
                addedList: 0
            }
        },
        created(){
            this.contact = {
                id: this.id,
                handler: this.handler,
                is_active: this.is_active,
                priority: this.priority,
                lists: [... this.lists]
            }
        },
        methods: {
            toggleContact(){
                console.log('toggling', this.contact.id)
                this.contact.is_active = !this.contact.is_active
            },
            removeList(list){
                this.contact.lists = this.contact.lists.filter(crt => crt != list ? crt:null)
            },
            addNewList(){
                if(this.addedList.id === 0){
                    return
                }
                this.contact.lists = [...this.contact.lists, this.addedList]
                this.addedList = 0
            },
            deleteContact(){
                if(this.contact.id){
                    axios.delete('api/contact/'+this.contact.id).then(resp => this.$emit('deleted', this.contact))
                }
                else{
                    this.$emit('deleted', this.contact)
                }
            }
        },
        computed: {
            ... mapState('contactLists', ['contactLists']),
            listIds(){
                return this.contact.lists.map(list => list.id)
            },
            newLists(){
                return this.contactLists
                    .filter(list => this.listIds.indexOf(list.id) === -1)
            },
            status(){
                return this.contact.is_active ? 'toggle_on' : 'toggle_off'
            },
            getClass(){
                return this.contact.is_active ? 'text-success' : 'text-danger'
            },
        }
    }
</script>

<style scoped>
.notification-status {
    font-size: 24px;
    cursor: pointer;
}
.contact-list {
    font-size: 12px;
    line-height: 24px;
    margin-right: 10px;
    font-weight: bold;
    white-space: nowrap;
    border-radius: 5px;
    padding: 0px 8px;
    margin-bottom: 4px;
}
.contact-list i{
    font-size: 14px;
    border-radius: 3px;
    margin-right: 4px;
}
</style>